import { useEffect } from "react";
import { Card, Typography, Tag, Divider, Spin, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../slice";
import { actions as orderListingActions } from "../../OrderListing/slice";
import * as selectors from "../selectors";
import { useState } from "react";
import { dateTimeToString } from "../../../../../utils/formatter";
import { FaClipboardList } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const { Title, Text } = Typography;

const RejectedOrders = ({ selectedCommodities, dateRange }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const rejectedOrders = useSelector(selectors.selectRejectedOrders);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      actions.getRejectedOrders({
        selectedCommodities,
        dateRange,
        onSuccess: () => {
          setIsLoading(false);
        },
        onFailure: () => {
          setIsLoading(false);
        },
      })
    );
  }, [dispatch, selectedCommodities, dateRange]);

  const handleViewAllClick = () => {
    dispatch(orderListingActions.setActiveNavOption("REJECTED"));
    history.push("/labPortal");
  };

  return (
    <div
      style={{
        padding: "24px",
        background: "#fff",
        borderRadius: "8px",
        border: "1px solid #f0f0f0",
        margin: "0 auto",
        minHeight: 755,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Title level={4}>Rejected Orders</Title>
        {rejectedOrders?.totalRejectedOrder ? (
          <Button 
            type="primary" 
            onClick={handleViewAllClick}
            style={{
              background: "linear-gradient(135deg, #f75e5eff, #f34984ff)",
              border: "none",
              borderRadius: "8px",
              padding: "4px 16px",
              height: "36px",
              fontWeight: 500,
            }}
          >
            View All Rejected Orders →
          </Button>
        ) : null}
      </div>

      {isLoading ? (
        <div
          style={{
            minHeight: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 24,
          }}
        >
          <Spin size="large" />
          <div style={{ marginTop: 12 }}>Loading...</div>
        </div>
      ) : rejectedOrders?.totalRejectedOrder === 0 ? (
        <div
          style={{
            minHeight: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "48px",
              marginBottom: "16px",
              color: "#d9d9d9",
            }}
          >
            <FaClipboardList color="#1C8A7A" />
          </div>
          <Title level={4} style={{ color: "#8c8c8c", marginBottom: 8 }}>
            No Rejected Orders
          </Title>
          <Text type="secondary" style={{ fontSize: "14px" }}>
            No rejected orders found in the selected period.
          </Text>
        </div>
      ) : (
        <>
          {" "}
          <div style={{ textAlign: "center", margin: "12px 0" }}>
            <Title level={2} style={{ color: "#ff4d4f", marginBottom: 0 }}>
              {rejectedOrders.totalRejectedOrder || 0}
            </Title>
            <Text type="secondary">Total Rejected</Text>
          </div>
          <Title level={5} style={{ color: "#ff4d4f", marginBottom: 8 }}>
            Latest{" "}
            {rejectedOrders.totalRejectedOrder > 3
              ? 3
              : rejectedOrders.totalRejectedOrder}{" "}
            Rejected Orders
          </Title>
          {rejectedOrders?.rejectedOrders?.slice(0, 3).map((order) => (
            <Card
              key={order._id}
              style={{
                border: "1px solid #ffccc7",
                background: "#fff",
                borderRadius: 8,
                marginBottom: 12,
              }}
              bodyStyle={{ padding: "16px" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginBottom: 8,
                }}
              >
                <Text strong>Order ID: {order.orderId}</Text>
                <Tag
                  color="red"
                  style={{ borderRadius: "12px", padding: "2px 10px" }}
                >
                  {order.status.label}
                </Tag>
              </div>

              <Text>
                <strong>Commodity:</strong> {order.commodityName}
              </Text>
              <br />
              <Text type="secondary">
                Delivery Date: {dateTimeToString(order.labDeliveryDate) || "-"}{" "}
                | Rejected:{" "}
                {dateTimeToString(
                  order.sampleReceivedByLabDetails?.rejectedByLabDate
                ) || "-"}
              </Text>

              <Divider style={{ margin: "12px 0" }} />

              <div
                style={{
                  background: "#fff2f0",
                  padding: "8px 12px",
                  borderRadius: "4px",
                }}
              >
                <Text>
                  <strong>Reason:</strong>{" "}
                  {order.sampleReceivedByLabDetails?.rejectedByLabReason}
                </Text>
              </div>
            </Card>
          ))}{" "}
        </>
      )}
    </div>
  );
};

export default RejectedOrders;
